import React from 'react';

import {
  TextField,
  InputAdornment,
  CircularProgress,
  IconButton,
} from '@mui/material';

import { ReactComponent as CloseIcon } from '../../../common/assets/icons/close_icon_filled.svg';
import { ReactComponent as SearchIcon } from '../../../common/assets/icons/search_icon_small_gray.svg';

type Props = {
  value: string;
  setValue: (value: string) => void;
  isFetching: boolean;
};

const AddCodeTextField: React.FC<Props> = ({ value, setValue, isFetching }) => {
  return (
    <TextField
      placeholder='Type your query here'
      variant='standard'
      fullWidth
      type='text'
      value={value}
      onChange={(e) => setValue(e.target.value)}
      InputProps={{
        style: {
          height: 50,
        },
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: isFetching ? (
          <InputAdornment position='end'>
            <CircularProgress size='20px' />
          </InputAdornment>
        ) : value.length !== 0 ? (
          <InputAdornment position='end'>
            <IconButton onClick={() => setValue('')}>
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};

export default AddCodeTextField;
